import axios from 'axios';

const API_BASE_URL = 'https://backend.gouniquejourneys.co.uk/api/vendors'; // Update with your actual backend URL

export const getAllVendors = async ({page,limit,sortOption}) => {
  try {
    const response = await axios.get(`${API_BASE_URL}?sort=${sortOption}&page=${page}&limit=${limit}`);
    return response.data; // Returns { success: true, vendors: [...] }
  } catch (error) {
    console.error('Error fetching vendors:', error.response?.data || error.message);
    return { success: false, error: error.response?.data || error.message };
  }
};
